import { useT } from "@/i18n/LanguageContext";

export default function Specs() {
  const { t } = useT();
  const rows = t.specs.rows;
  const headers = t.specs.headers;
  return (
    <section
      id="specs"
      data-testid="specs-section"
      className="relative bg-[#0A0A0A] border-b border-white/10"
    >
      <div className="grid grid-cols-12 border-b border-white/10">
        <div className="col-span-12 md:col-span-3 border-r border-white/10 px-6 sm:px-8 py-10 md:py-20">
          <p className="text-[10px] uppercase tracking-[0.3em] text-white/50">
            {t.specs.label}
          </p>
        </div>
        <div className="col-span-12 md:col-span-9 px-6 sm:px-10 py-10 md:py-20">
          <h2
            data-testid="specs-headline"
            className="font-display font-bold uppercase tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-3xl"
          >
            {t.specs.title}
          </h2>
          {t.specs.intro && (
            <p className="mt-6 text-base text-white/70 max-w-xl">
              {t.specs.intro}
            </p>
          )}
        </div>
      </div>
      <div className="grid grid-cols-12 border-b border-white/10 bg-white/[0.02]">
        <div className="col-span-12 md:col-span-4 px-6 sm:px-10 py-4 text-[10px] uppercase tracking-[0.3em] text-white/50">
          {headers[0]}
        </div>
        <div className="hidden md:block col-span-3 px-6 sm:px-10 py-4 text-[10px] uppercase tracking-[0.3em] text-white/50 border-l border-white/10">
          {headers[1]}
        </div>
        <div className="hidden md:block col-span-5 px-6 sm:px-10 py-4 text-[10px] uppercase tracking-[0.3em] text-white/50 border-l border-white/10">
          {headers[2]}
        </div>
      </div>

      {rows.map(([k, std, opt], i) => (
        <div
          key={`${k}-${i}`}
          data-testid={`spec-row-${i}`}
          className={`grid grid-cols-12 ${
            i !== rows.length - 1 ? "border-b" : ""
          } border-white/10 hover:bg-white/[0.03] transition-colors`}
        >
          <div className="col-span-12 md:col-span-4 px-6 sm:px-10 py-5 text-[11px] uppercase tracking-[0.22em] text-white/50">
            {k}
          </div>
          <div className="col-span-12 md:col-span-3 px-6 sm:px-10 py-5 md:py-5 font-display text-base md:text-lg text-white border-t md:border-t-0 md:border-l border-white/10">
            <span className="md:hidden text-[10px] uppercase tracking-[0.25em] text-white/40 mr-2">
              {headers[1]}:
            </span>
            {std}
          </div>
          <div className="col-span-12 md:col-span-5 px-6 sm:px-10 py-5 md:py-5 text-sm text-white/70 border-t md:border-t-0 md:border-l border-white/10">
            <span className="md:hidden text-[10px] uppercase tracking-[0.25em] text-white/40 mr-2">
              {headers[2]}:
            </span>
            {opt}
          </div>
        </div>
      ))}
    </section>
  );
}
